export default {
  refreshCache:'Refresh the cache',
  confirm: ' confirrm',
  cancel: ' cancel',
  success: 'success',
  error: 'failed',
  del: 'delete',
  search: 'search',
  detail: 'detasil',
  editor: ' edit',
  login: 'login',

  empty: 'empty',
  emptyValue: 'Null value',
  add: ' add',
  export: 'export',
  hint: 'reminder',
  transferAmount: 'Amount transfer',
  withdraw: 'withdraw',
  review: 'review',
  pass: 'password',
  reject: 'reject',
  next: 'next',
  recharge: 'recharge',
  start: 'start',
  start1: 'Start auto refresh',
  stop: 'stop',
  stop1: 'Close auto refresh',
  submit: 'Submit',
  manual: 'Make up',
  callback: 'Callback',
  allOlder:'Batch order replenishment',
  qrCode: 'QR code'
};



// WEBPACK FOOTER //
// ./src/i18n/lang/en/btns.js